import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetchDataSuccess = (doctordata: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: doctordata,
});
export const fetchdatasss = (hospitaldata: any) => ({
    type: 'FETCH_DATA1_SUCCESS',
    payload: hospitaldata,
});

export const fetchDoctorDatasss = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid};
            const apiname = SUPRIVISOR_API.sdoctordata;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchHospitalData = (id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {doctorid:id,q:3};
            const apiname = SUPRIVISOR_API.shospitaldata;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdatasss(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
